// Styles
import "./discover-look.scss";

if (!window.dAgency) window.dAgency = {};

window.dAgency.initDiscoverLookSection = (context) => {
  const discoverLookSection = context.closest(".shopify-section");
  if (!discoverLookSection) return;

  const discoverLookContainer = discoverLookSection.querySelector(
    ".discover-look__container"
  );
  const lookItem = discoverLookContainer.querySelectorAll(
    ".discover-look__wrapper"
  );

  lookItem.forEach((item) => {
    item?.querySelector("figcaption")?.addEventListener("click", (e) => {
      item.classList.toggle("show-products");
    });
  });
};

const initDiscoverLookSection = (el) => {
  window.dAgency.initDiscoverLookSection(el);
};

const initContainers = () => {
  const containers = document.querySelectorAll(".discover-look__container");
  [].forEach.call(containers, initDiscoverLookSection);
};

if (document.readyState != "loading") {
  initContainers();
} else {
  document.addEventListener("DOMContentLoaded", initContainers);
}
